<template>
  <section class="plat">
    <div class="plat__glow plat__glow--blue" aria-hidden="true"></div>
    <div class="plat__dots" aria-hidden="true"></div>

    <div class="plat__container">
      <div class="plat__head reveal">
        <p class="plat__eyebrow">Plateforme</p>
        <h2 class="plat__title">{{ $t('home_page.plateforme_section_title') }}</h2>
        <span class="plat__bar"></span>
      </div>

      <div class="plat__grid">
        <article
          v-for="(item, i) in items"
          :key="i"
          class="plat__card reveal"
          :class="{ 'plat__card--accent': item.accent }"
        >
          <span class="plat__icon" :class="'plat__icon--' + ((i % 2) + 1)">
            <img :src="item.icon" :alt="item.title" loading="lazy" />
          </span>
          <h3 class="plat__card-title">{{ item.title }}</h3>
          <p class="plat__card-text">{{ item.content }}</p>
          <button type="button" class="plat__more" @click="goToContactForm(item.key)">
            {{ $t('contact.en_savoir_label') }} <i class="fas fa-arrow-right"></i>
          </button>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'plateforme_section',
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),
  computed: {
    items() {
      return [
        {
          key: 'product',
          icon: require('../../../assets/img/home/new_home/platform_section/subscription.png'),
          title: this.$t('home_page.product_plateforme_section_title'),
          content: this.$t('home_page.product_plateforme_section_content')
        },
        {
          key: 'souscription',
          icon: require('../../../assets/img/home/new_home/platform_section/product.png'),
          title: this.$t('home_page.souscription_plateforme_section_title'),
          content: this.$t('home_page.souscription_plateforme_section_content')
        },
        {
          key: 'pilotage',
          icon: require('../../../assets/img/home/new_home/platform_section/data.png'),
          title: this.$t('home_page.pilotage_plateforme_section_title'),
          content: this.$t('home_page.pilotage_plateforme_section_content')
        },
        {
          key: 'innovation',
          icon: require('../../../assets/img/home/new_home/platform_section/api.png'),
          title: this.$t('home_page.innovation_plateforme_section_title'),
          content: this.$t('home_page.innovation_plateforme_section_content'),
          accent: true
        }
      ];
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    goToContactForm(item) {
      let url = "/contactform/";
      url += item;
      this.$router.push({ path: url });
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.plat {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #fff 0%, #FFFBF6 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.4;
    pointer-events: none;

    &--blue {
      width: 460px;
      height: 460px;
      background: rgba(91, 148, 188, 0.28);
      top: -160px;
      left: -120px;
    }
  }

  &__dots {
    position: absolute;
    bottom: 6%;
    right: 4%;
    width: 120px;
    height: 120px;
    background-image: radial-gradient(rgba(255, 164, 9, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 56px;
  }

  &__eyebrow {
    display: inline-block;
    background: rgba(91, 148, 188, 0.14);
    color: #3d7ba6;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 999px;
    margin: 0 0 18px;
  }

  &__title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 18px;
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
  }

  &__card {
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 24px;
    padding: 40px 36px 34px;
    box-shadow: 0 18px 44px rgba(43, 43, 43, 0.07);
    transition: transform 0.35s cubic-bezier(0.22, 0.61, 0.36, 1),
      box-shadow 0.35s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 30px 60px rgba(43, 43, 43, 0.12);
    }

    &--accent {
      background: linear-gradient(140deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
      border-color: transparent;

      .plat__card-title,
      .plat__card-text {
        color: #fff;
      }

      .plat__more {
        color: #fff;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 68px;
    border-radius: 20px;
    margin-bottom: 24px;

    img {
      width: 36px;
      height: 36px;
      object-fit: contain;
    }

    &--1 {
      background: #fff3df;

      img {
        filter: hue-rotate(0deg);
      }
    }

    &--2 {
      background: #eaf3f9;
    }
  }

  &__card--accent .plat__icon {
    background: rgba(255, 255, 255, 0.25);
  }

  &__card-title {
    font-size: 21px;
    font-weight: 800;
    line-height: 1.3;
    color: #2b2b2b;
    margin: 0 0 12px;
  }

  &__card-text {
    margin: 0 0 22px;
    font-size: 15px;
    line-height: 1.7;
    color: #59595b;
    flex: 1;
  }

  &__more {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    align-self: flex-start;
    background: none;
    border: none;
    padding: 0;
    font-size: 15px;
    font-weight: 700;
    color: #ffa409;
    cursor: pointer;
    transition: gap 0.25s ease, color 0.25s ease;

    i {
      font-size: 14px;
      transition: transform 0.25s ease;
    }

    &:hover {
      color: #f57c00;

      i {
        transform: translateX(4px);
      }
    }
  }
}

@media (max-width: 991px) {
  .plat {
    padding: 72px 24px;

    &__grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    &__title {
      font-size: 32px;
    }
  }
}

@media (max-width: 600px) {
  .plat {
    padding: 56px 20px;

    &__card {
      padding: 30px 24px;
    }

    &__icon {
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
    }
  }
}

</style>
